var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.9C0 0.402944 0.402944 0 0.9 0H3.32424C3.73127 0 4.08763 0.273178 4.19335 0.666235L5.01796 3.73203L22.7782 4.9182C23.2509 4.94977 23.6182 5.34243 23.6182 5.8162V13.1905C23.6182 13.6604 23.2567 14.0512 22.7882 14.0878L7.03059 15.3168C6.59866 15.3505 6.20403 15.0717 6.0915 14.6533L3.44687 4.82092L2.63433 1.8H0.9C0.402944 1.8 0 1.39706 0 0.9ZM9.04654 6.8298C8.92755 6.3472 8.43986 6.05243 7.95726 6.17142C7.47465 6.29041 7.17988 6.7781 7.29887 7.2607L8.51099 12.1769C8.62998 12.6595 9.11767 12.9543 9.60028 12.8353C10.0829 12.7163 10.3776 12.2286 10.2587 11.746L9.04654 6.8298ZM13.5017 6.46132C13.9939 6.39197 14.4491 6.73476 14.5185 7.22695L15.1246 11.5286C15.1939 12.0208 14.8511 12.476 14.3589 12.5454C13.8667 12.6147 13.4115 12.2719 13.3422 11.7798L12.7361 7.47807C12.6668 6.98588 13.0095 6.53066 13.5017 6.46132ZM19.9818 7.65978C19.9818 7.16272 19.5788 6.75978 19.0818 6.75978C18.5847 6.75978 18.1818 7.16272 18.1818 7.65978V11.3469C18.1818 11.844 18.5847 12.2469 19.0818 12.2469C19.5788 12.2469 19.9818 11.844 19.9818 11.3469V7.65978ZM11.809 19.3358C11.809 20.6933 10.7237 21.7939 9.38479 21.7939C8.04592 21.7939 6.96055 20.6933 6.96055 19.3358C6.96055 17.9782 8.04592 16.8777 9.38479 16.8777C10.7237 16.8777 11.809 17.9782 11.809 19.3358ZM19.0818 21.7939C20.4207 21.7939 21.5061 20.6933 21.5061 19.3358C21.5061 17.9782 20.4207 16.8777 19.0818 16.8777C17.7429 16.8777 16.6576 17.9782 16.6576 19.3358C16.6576 20.6933 17.7429 21.7939 19.0818 21.7939Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.ebb5d102019ae730e178d243f9b27f0e.svg";
export { ForwardRef as ReactComponent };